export default function RecommendationDocumentDirective() {
  return {
    template: require('./recommendation-document.html'),
    scope: {
      recommendationId: '=',
      canEdit: '=',
      canDelete: '=',
      recommendationDocument: '=',
    },
    controller: 'RecommendationDocumentController',
    controllerAs: 'recommendationDocumentVM',
    bindToController: true,
    replace: true
  };
}
